import { environment, IEnvironment } from '@/utils/environment';
import Axios from 'axios';

export function getUserRole(): Promise<any> {
    return Axios.get(`${(environment() as IEnvironment).apiBaseUrl}/v1/user/role`);
}